import { Divider } from 'antd'

const FormDivider = () => <Divider className="my-4 border-bz-gray-400" />

export default FormDivider
